import { SVGProps, Ref, forwardRef } from 'react';

export const ShieldFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m8 .5 6 2.045v4.773a8.55 8.55 0 0 1-1.667 5.114C11.341 13.796 9.667 15.159 8 15.5c-1.667-.34-3.333-1.671-4.333-3.068S2 9.364 2 7.318V2.545z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ShieldFilledSize16Glyph.displayName = 'ShieldFilledSize16Glyph';
